export default {
    environment: 'staging',
    appHostname: 'practitioner.luminalearning-nonproduction.com',
    ssoV1Hostname: 'single-sign-on.luminalearning-nonproduction.com',
    ssoV2Hostname: 'sso.v2.luminalearning-nonproduction.com',
    financeHostname: 'finance.luminalearning-nonproduction.com',
    graphqlGatewayHostname: 'graphql.api.luminalearning-nonproduction.com',
    luminaOnlineHostname: 'www.luminalearning-nonproduction.com',
    luminaOpenBadgesClientHostname: 'badges.luminalearning-nonproduction.com',
    luminaGetQualifiedUrlHostname: 'luminalearning.com/become-a-practitioner/',
    teamsHostname: 'team.luminalearning-nonproduction.com',
    AtsHostname: 'applicant-tracker.luminalearning-nonproduction.com',
    eLearningHostname: 'e-learning.luminalearning-nonproduction.com',
    openApiHostname: 'api2.luminalearning-nonproduction.com',
    keycloakServerUrl: 'auth.luminalearning-nonproduction.com',
    participantProjectPaginationLimit: 10,
    projectAndSearchPaginationLimit: 20,
    forceHttps: true,
};
